// AddCourseDrawer.tsx
import { useState } from 'react';
import { Drawer, Group, Button } from '@mantine/core';
import { toast } from '@/components/ui/providers/AlertProvider';
import { useACCourseService } from '@actschurch/ccms-sdk';
import CourseForm, { CourseFormState, EMPTY_COURSE_FORM } from './CourseForm';

interface AddCourseDrawerProps {
  opened: boolean;
  onClose: () => void;
  onCreated: () => Promise<void> | void;
}

export default function AddCourseDrawer({ opened, onClose, onCreated }: AddCourseDrawerProps) {
  const courseService = useACCourseService();
  const [form, setForm] = useState<CourseFormState>(EMPTY_COURSE_FORM);
  const [saving, setSaving] = useState(false);

  const handleClose = () => {
    setForm(EMPTY_COURSE_FORM);
    onClose();
  };

  const handleSave = async () => {
    if (!form.name?.trim()) {
      toast.error('Validation', 'Course name is required.');
      return;
    }
    setSaving(true);
    try {
      const { isActive, ...payload } = form;
      await courseService.create(payload);
      toast.success('Created', 'Course created successfully.');
      await onCreated();
      handleClose();
    } catch (e) {
      console.error(e);
      toast.error('Error', 'Failed to create course.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Drawer opened={opened} onClose={handleClose} title="Add Course" position="right" size="md" padding="md">
      <CourseForm form={form} onChange={setForm} uploadRecordId="new" />
      <Group justify="flex-end" mt="lg">
        <Button variant="subtle" onClick={handleClose}>Cancel</Button>
        <Button loading={saving} onClick={handleSave}>Save</Button>
      </Group>
    </Drawer>
  );
}